import { createFileRoute } from '@tanstack/react-router'
import { TermsOfServicePage } from '@/components/infoPages/TermsOfServicePage'
import { withPublicPageSeo } from '@/modules/seo'

const TermsOfServicePageWithSeo = withPublicPageSeo('termsOfService', TermsOfServicePage)

export const Route = createFileRoute('/terms-of-service')({
  component: TermsOfServicePageWithSeo,
})

